import { useState, useRef} from "react";
import 'animate.css';

const ContactFloating = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleIcons = () => {
        setIsOpen(!isOpen);
    };

    const mainButtonRef = useRef(null);
    
    const handleMouseEnter = (ref) => {
        if (ref.current){
            ref.current.classList.add("animate__animated", "animate__pulse","animate__infinite");
        }
    }
    const handleMouseLeave = (ref) => {
        if (ref.current){
            ref.current.classList.remove("animate__animated", "animate__pulse","animate__infinite");
        }
    }

    return (
        <div ref={mainButtonRef}  onMouseEnter={()=>handleMouseEnter(mainButtonRef)} onMouseLeave={()=>handleMouseLeave(mainButtonRef)} style={styles.container}>
            <div
                style={{
                    ...styles.iconsContainer,
                    maxWidth: isOpen ? "300px" : "0", 
                    opacity: isOpen ? 1 : 0,
                    overflow: "hidden",
                }}
            >
             <a
    href="https://wa.me/5492634588256?text=Hola,%20quisiera%20consultar%20a%20un%20vendedor"
    target="_blank"
    rel="noopener noreferrer"
    style={styles.iconLink}
>
    <span style={styles.linkText}>Ventas</span>
    <img
        src="/whatsapp-logo.svg"
        alt="WhatsApp 1"
        style={styles.icon}
    />
</a>
<a
    href="https://wa.me/2635000305?text=Hola,%20quisiera%20hacer%20una%20consulta%20de%20servicios"
    target="_blank"
    rel="noopener noreferrer"
    style={styles.iconLink}
>
    <span style={styles.linkText}>Servicios</span>
    <img
        src="/whatsapp-logo.svg"
        alt="WhatsApp 2"
        style={styles.icon}
    />
</a>
            </div>
            <button onClick={toggleIcons} style={styles.floatingButton}>
                <img
                    src="/whatsapp-logo.svg"
                    alt="WhatsApp Toggle"
                    style={styles.iconMain}
                />
            </button>
        </div>
    );
};

const styles = {
    container: {
        position: "fixed",
        bottom: "150px",
        right: "20px", 
        zIndex: 10,
        display: "flex",
        alignItems: "center", 
    },
    iconsContainer: {
        display: "flex", 
        flexDirection: "row", 
        alignItems: "center",
        marginRight: "10px", 
        transition: "max-width 0.3s ease, opacity 0.3s ease", 
    },
    iconLink: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#25D366", 
        color: "#fff", 
        textDecoration: "none",
        padding: "10px 15px", 
        borderRadius: "8px", 
        marginRight: "10px", 
        fontSize: "16px",
        fontWeight: "bold", 
        transition: "background-color 0.3s ease", 
    },
    iconLinkHover: {
        backgroundColor: "#1DA851",
    },
    linkText: {
        marginRight: "10px", 
    },
    icon: {
        width: "30px",
        height: "30px",
    },
    iconMain: {
        width: "50px",
        height: "50px",
    },
    floatingButton: {
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
    },
};

export default ContactFloating;